import { safeDefine } from "../../registration/safe-define.js";
import { StatusIndicatorElement } from "../../ui/status-indicator/element.js";
//#region src/define/ui/status-indicator.ts
safeDefine(StatusIndicatorElement);
//#endregion

//# sourceMappingURL=status-indicator.js.map